import React, { Component } from 'react'
import PropTypes from 'prop-types'
import produce from 'immer'
import { get } from 'lodash'

import { withNamespaces } from '@edulastic/localization'
import { ChoiceDimensions } from '@edulastic/constants'
import { getFormattedAttrId } from '@edulastic/common/src/helpers'

import {
  Layout,
  FontSizeOption,
  ResponseContainerPositionOption,
  StemNumerationOption,
  NumberInput,
} from '../../../containers/WidgetOptions/components'
import { Row } from '../../../styled/WidgetOptions/Row'
import { Col } from '../../../styled/WidgetOptions/Col'
import Question from '../../../components/Question'

const { maxWidth: choiceMaxW, minWidth: choiceMinW } = ChoiceDimensions
class LayoutWrapper extends Component {
  render() {
    const {
      item,
      setQuestionData,
      advancedAreOpen,
      t,
      fillSections,
      cleanSections,
    } = this.props

    const changeUIStyle = (prop, val) => {
      setQuestionData(
        produce(item, (draft) => {
          if (!draft.uiStyle) {
            draft.uiStyle = {}
          }
          draft.uiStyle[prop] = val
        })
      )
    }

    return (
      <Question
        section="advanced"
        label={t('component.options.display')}
        advancedAreOpen={advancedAreOpen}
        fillSections={fillSections}
        cleanSections={cleanSections}
      >
        <Layout
          id={getFormattedAttrId(
            `${item?.title}-${t('component.options.display')}`
          )}
        >
          <Row gutter={36}>
            <Col md={12}>
              <ResponseContainerPositionOption
                onChange={(val) =>
                  changeUIStyle('possibilityListPosition', val)
                }
                value={get(item, 'uiStyle.possibilityListPosition', 'bottom')}
              />
            </Col>
            <Col md={12}>
              <StemNumerationOption
                onChange={(val) =>
                  changeUIStyle('validationStemNumeration', val)
                }
                value={get(
                  item,
                  'uiStyle.validationStemNumeration',
                  'numerical'
                )}
              />
            </Col>
          </Row>

          <Row gutter={36}>
            <Col md={12} data-cy="choiceMinWidth">
              <NumberInput
                label={t('component.options.choiceMinWidth')}
                onChange={(val) => changeUIStyle('choiceMinWidth', +val)}
                value={get(item, 'uiStyle.choiceMinWidth', choiceMinW)}
              />
            </Col>
            <Col md={12} data-cy="choiceMaxWidth">
              <NumberInput
                label={t('component.options.choiceMaxWidth')}
                onChange={(val) => changeUIStyle('choiceMaxWidth', +val)}
                value={get(item, 'uiStyle.choiceMaxWidth', choiceMaxW)}
              />
            </Col>
          </Row>

          <Row gutter={36}>
            <Col md={12}>
              <FontSizeOption
                onChange={(val) => changeUIStyle('fontsize', val)}
                value={get(item, 'uiStyle.fontsize', 'normal')}
              />
            </Col>
          </Row>
        </Layout>
      </Question>
    )
  }
}

LayoutWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  setQuestionData: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  fillSections: PropTypes.func,
  cleanSections: PropTypes.func,
  advancedAreOpen: PropTypes.bool,
}

LayoutWrapper.defaultProps = {
  advancedAreOpen: false,
  fillSections: () => {},
  cleanSections: () => {},
}

export default withNamespaces('assessment')(LayoutWrapper)
